module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/master/department/dept-view/dept-view.component.css
// module id = ./src/app/master/department/dept-view/dept-view.component.css
// module chunks = main